import Cookies from 'js-cookie';

class HidePrices {
    constructor() {
        this.init();
    }

    init() {
        this.getCookie();
        this.hidePricesCheckbox = document.getElementById('hide-prices');

        if (!this.hidePricesCheckbox) return;
        this.addEventListeners();
        this.updatePriceUI();
    }

    addEventListeners() {
        this.hidePricesCheckbox.addEventListener('change', () => {
            if (this.hidePricesCheckbox.checked) {
                this.hidePrices();
            } else {
                this.showPrices();
            }
        });
    }

    hidePrices() {
        this.hiddenPrices = true;
        this.updatePriceUI();
        this.updateCookie();
    }

    showPrices() {
        this.hiddenPrices = false;
        this.updatePriceUI();
        this.updateCookie();
    }

    updatePriceUI() {
        document.body.classList.toggle('prices-hidden', this.hiddenPrices);

        this.hidePricesCheckbox.checked = this.hiddenPrices;
    }

    getCookie() {
        this.hiddenPrices = Cookies.get('hiddenPrices') === 'true';
    }

    updateCookie() {
        const now = new Date();
        now.setTime(now.getTime() + 60 * 60 * 1000);
        Cookies.set('hiddenPrices', this.hiddenPrices, {
            expires: now,
            path: '/'
        });
    }
}

new HidePrices();
